module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-48x48-8fe36947262ab3a8cd71f3419b5aeb94.png";